<!-- 会员中心 -->

<template>
<div class="appdow">
    <div class="userbox">
        <div class="userdata">
            <div class="userimg">
                <img :src="userinfo.avatarUrl" alt="" srcset="" />
            </div>
            <div class="userlist">
                <ul>
                    <li class="username">{{userinfo.nickname}}</li>
                    <li class="phone">{{userinfo.mobile}}</li>
                    <li class="date" v-show="!userinfo.isVip">未开通会员</li>
                    <li class="date" v-show="userinfo.isVip">{{expireTime}}日到期</li>
                </ul>
            </div>
        </div>

        <div class="savedata">
            <h4>开通时长</h4>
            <div class="money_row">
                <div :class="active == index ? 'active_box money_box' : 'money_box'" v-for="(item, index) in vipdate" :key="index" @click="vip_num(index,item)">
                    <div class="money_date">{{ item.name }}</div>
                    <div class="num_box">
                        <p class="money_num">
                            ￥<span>{{ item.money }}</span> <span class="del">￥{{ item.originMoney }}&nbsp;</span>
                        </p>
                        <p class="date_num">￥{{ (item.money/(item.day/30)).toFixed(2) }}/月</p>
                    </div>
                    <img class="gougou" v-show="active == index" src="/static/images/vip_gougou.png" alt="" srcset="" />
                </div>
            </div>
            <h4>支付方式</h4>
            <div class="code_box">
                <div class="imgbox" id="qrcode" v-loading="loading" @click="vipcreate">

                </div>
                <img style="width: 120px;height: 120px;position: absolute;" src="../../../static/images/lose.png" alt="" @click="codeImgC" v-show="iscodeImg">
                <div class="applaydata">
                    <p class="aplay_num">￥<span>{{itemList.money}}</span>
                        <span style="font-size: 14px;color: #989DA2;">(已节省<span style="color: #C79757;font-size: 14px;">{{ itemList.originMoney-itemList.money }}</span>元)</span>
                    </p>
                    <p class="aplay_p">
                        使用微信、支付宝APP扫码支付
                    </p>
                    <p class="aplay_from">
                        <img src="/static/images/vip_wexin.png" alt="" srcset="" />
                        <img src="/static/images/vip_zhifubao.png" alt="" srcset="" />
                    </p>
                </div>
            </div>

            <p class="text">
                支付遇到问题？咨询客服
                <button class="erweima">
                    <img src="/static/images/vip_erweima.png" alt="" />客服微信
                    <img :src="contactList.wxUrl" alt="" class="wxImg">
                </button>
            </p>
        </div>
    </div>
    <div class="privilege">
        <h3>
            <img src="/static/images/vip_bt_zuo.png" alt="" />会员特权<img src="/static/images/vip_bt_you.png" alt="" />
        </h3>
        <div class="privilegelist">
            <div class="item_box" v-for="(item, index) in privilegelist" :key="index">
                <div class="imgbox"><img :src="item.imgurl" alt="" srcset="" /></div>
                <div class="text_box">
                    <h5>{{ item.title }}</h5>
                    <p>{{ item.content }}</p>
                </div>
            </div>
        </div>

        <h3>
            <img src="/static/images/vip_bt_zuo.png" alt="" />特权对比<img src="/static/images/vip_bt_you.png" alt="" />
        </h3>
        <div class="pk_list">
            <ul v-for="(item, index) in vip_pk" :key="index">
                <li v-for="(items, j) in item" :key="j" :class="items.button ? 'btn' : ''">
                    {{ items.content }}
                    <img :src="items.icon" alt="" srcset="" :class="items.class" />
                    <button v-if="items.button" @click="open">立即开通</button>
                </li>
            </ul>
        </div>
    </div>

    <!-- 成功弹窗 -->
    <el-dialog :visible.sync="vipPop" width="30%" center>
        <div class="modifyM-box" style="text-align: center;">
            <div class="vip-xbt">笔杆论文会员</div>
            <div class="vip-suc">
                <img src="../../../static/images/acc_state_sucess.png" alt="">
                <p>开通成功!</p>
            </div>
            <p class="vip-t">恭喜您成为尊贵的笔杆论文会员，快去写作吧！</p>
        </div>
    </el-dialog>

</div>
</template>

<script>
import dataobj from './data'
import QRCode from 'qrcodejs2' // 引入qrcode
export default {
    data: function () {
        return {
            active: 0,
            vipdate: dataobj.vipdate,
            privilegelist: dataobj.privilegelist,
            vip_pk: dataobj.vip_pk,
            expireTime: '',
            itemList: {},
            userinfo: {
                avatarUrl: ''
            },
            vipcreatelist: {},
            // 轮询
            stateTiem: {},
            iscodeImg: false,
            loading: true,
            // 开通弹窗
            vipPop: false,

            contactList: {}

        }
    },
    created: function () {
        this.userinfo = JSON.parse(localStorage.getItem('userinfo'))
        if (this.userinfo != null && this.userinfo.expireTime != null) {
            this.expireTime = this.userinfo.expireTime.split(' ')[0] || ''
        }
    },
    mounted() {
        this.vipList()
        this.getContact()
    },
    methods: {
        getContact() {
            this.oauthapi.contact().then(res => {
                this.contactList = res.data
            })
        },
        vip_num: function (index, item) {
            this.active = index
            this.itemList = item
            this.vipcreate(item.id)
            clearTimeout(this.stateTiem)
        },
        open: function () {
            window.scrollTo(0, 0)
        },
        // 获取vip产品列表
        vipList() {
            this.oauthapi.vipProduct().then(res => {
                if (res.code == 0) {
                    this.vipdate = res.data
                    this.itemList = res.data[0]
                    this.vipcreate(res.data[0].id)
                }
            })
        },
        // 创建二维码订单,返回url
        vipcreate(id) {
            let VipId = {
                systemVipId: id
            }
            var that = this
            this.oauthapi.vipcreate(VipId).then(res => {
                if (res.code == 0) {
                    this.loading = false
                    this.iscodeImg = false
                    this.vipcreatelist = res.data
                    document.getElementById('qrcode').innerHTML = ''
                    let qrcode = new QRCode('qrcode', {
                        width: 120,
                        height: 120,
                        text: res.data.url // 二维码地址
                    })
                    // 轮询
                    this.getOrderState()
                    var that = this
                    // 90秒后二维码失效
                    setTimeout(function () {
                        document.getElementById('qrcode').innerHTML = ''
                        that.iscodeImg = true
                        clearTimeout(that.stateTiem)
                    }, 90000)
                } else {
                    var that = this
                    // 服务器错误2秒后失效
                    setTimeout(function () {
                        that.loading = false
                        that.iscodeImg = true
                        clearTimeout(that.stateTiem)
                    }, 2000)
                }
            })
        },
        // 获取订单状态
        getOrderState() {
            let orderIdParams = {
                orderId: this.vipcreatelist.orderId
            }
            var that = this
            this.oauthapi.getOrderState(orderIdParams).then(res => {
                if (res.data == false) {
                    this.stateTiem = setTimeout(function () {
                        that.getOrderState()
                    }, 3000)
                } else {
                    this.vipPop = true
                    clearTimeout(that.stateTiem)
                    // 更新用户信息
                    this.oauthapi.userInfo().then(res => {
                        localStorage.setItem('userinfo', JSON.stringify(res.data))
                        this.userinfo = res.data
                    })
                }
            })
        },
        // 点击二维码失效
        codeImgC() {
            this.vipcreate(this.active + 1)
        }
    },
    destroyed() {
        clearTimeout(this.stateTiem)
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.appdow {
    .userbox {
        width: $mWidth;
        margin: 0 auto;
        border: 1px solid $boxcolor;

        .userdata {
            width: $mWidth - 120px;
            background: $boxcolor;
            display: flex;
            padding: 40px 60px;

            .userimg {
                width: 80px;
                height: 80px;

                img {
                    width: 80px;
                    height: 80px;
                }
            }

            .username {
                font-size: 1.15rem;
                font-weight: 400;
                color: #333439;
            }

            .phone {
                font-size: 1rem;
                font-weight: 400;
                color: #66686e;
                margin-top: 5px;
            }

            .date {
                color: #989da2;
                font-size: 0.79rem;
                font-weight: 400;
                margin-top: 12px;
            }
        }

        .savedata {
            padding: 30px 60px;
        }

        h4 {
            font-size: 1rem;
            color: #333439;
        }

        .money_row {
            display: flex;
            margin: 30px 0;

            .money_box {
                border-radius: 6px;
                border: 1px solid #d6d9dc;
                height: 100px;
                margin-right: 20px;
                display: flex;
                position: relative;
                cursor: pointer;

                .gougou {
                    height: 35px;
                    width: 35px;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }

                .num_box {
                    padding: 0 27px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .money_num {
                        font-weight: bold;
                        font-style: italic;
                        color: #c79757;
                        font-size: 18px;

                        span {
                            font-size: 36px;
                            font-weight: bold;
                            font-style: italic;
                        }

                        .del {
                            font-size: 14px;
                            font-weight: 400;
                            text-decoration: line-through;
                            color: #989da2;
                        }
                    }

                    .date_num {
                        font-size: 16px;
                        font-weight: 400;
                        color: #66686e;
                    }
                }
            }

            .active_box {
                border: 1px solid #c79757;
                background: rgba(199, 151, 87, 0.2);

                .money_date {
                    border-right: 1px dashed #c79757;
                }
            }

            .money_date {
                border-right: 1px dashed #d6d9dc;
                display: flex;
                width: 18px;
                padding: 0 24px;
                align-items: center;
                margin-right: 10px;
                height: 100%;
                font-size: 14px;
                font-weight: 600;
                color: #333439;
                line-height: 17px;
            }
        }

        .applaydata {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 20px;
        }

        .code_box {
            margin-top: 30px;
            display: flex;

            .imgbox {
                width: 120px;
                height: 120px;

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }

            .aplay_num {
                font-size: 18px;
                font-weight: bold;
                font-style: italic;
                color: #c79757;

                span {
                    font-size: 36px;
                }
            }

            .aplay_p {
                font-size: 14px;
                font-weight: 400;
                color: #989da2;
            }

            .aplay_from {
                margin-bottom: 5px;

                img {
                    width: 24px;
                }
            }
        }

        .text {
            text-align: right;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            display: flex;
            color: #989da2;
            justify-content: flex-end;

            .erweima {
                color: #5576bd;
                display: flex;
                align-items: center;
                margin-left: 16px;
                padding: 0;
                border: 0;
                background: none;
                cursor: pointer;

                img {
                    width: 12px;
                    height: 12px;
                }

                .wxImg {
                    width: 9rem;
                    height: 9rem;
                    display: none;
                    position: absolute;
                    z-index: 2;
                    margin-top: 75px;
                    margin-left: -4px;
                }

                &:hover {
                    .wxImg {
                        display: block;
                    }
                }
            }

        }
    }

    .privilege {
        width: $mWidth;
        margin: 0 auto;

        h3 {
            font-size: 1.8rem;
            font-weight: bold;
            color: #333439;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 8rem;

            img {
                margin: 0 12px;
                width: 36px;
                height: 17px;
            }
        }

        .privilegelist {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            .item_box {
                display: flex;
                width: 215px;
                margin: 0 80px;
                margin-top: 54px;
                align-items: center;

                .imgbox {
                    width: 43px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        max-width: 41px;
                    }
                }

                .text_box {
                    margin-left: 18px;

                    h5 {
                        font-size: 18px;
                        font-weight: bold;
                    }

                    p {
                        font-size: 14px;
                        font-weight: 400;
                        color: #989da2;
                    }
                }
            }
        }

        .pk_list {
            display: flex;
            justify-content: center;
            margin: 80px 0 120px 0px;

            ul:nth-of-type(2) {
                background: #fff4e5;

                li {
                    color: #c99b5d;
                }

                li:first-child {
                    color: #c99b5d;
                }
            }

            ul:nth-of-type(1) {
                li {
                    border-left: 1px solid $bdcolor;
                }
            }

            ul {
                width: 400px;
                padding: 0;

                li:first-child {
                    border-bottom: 2px solid $bdcolor;
                    color: #66686e;
                    font-size: 20px;
                    font-weight: bold;
                    border-top: 1px solid $bdcolor;
                }

                li {
                    height: 52px;
                    line-height: 52px;
                    border-bottom: 1px solid $bdcolor;
                    border-right: 1px solid $bdcolor;
                    text-align: center;
                    font-size: 16px;
                    color: #989da2;

                    img {
                        width: 21px;
                    }

                    .cha {
                        width: 15px;
                    }
                }

                .btn {
                    height: auto;
                    display: flex;
                    flex-wrap: wrap;
                    flex-direction: column;
                    align-items: center;
                    padding: 10px 0 33px 0;
                    font-size: 18px;
                    font-weight: bold;

                    button {
                        width: 108px;
                        height: 36px;
                        background: linear-gradient(0deg, #c79757 0%, #e1ab62 100%);
                        border-radius: 18px;
                        border: none;
                        margin-top: -5px;
                        font-size: 18px;
                        font-weight: bold;
                        color: #ffffff;
                    }
                }
            }
        }
    }

    .vip-xbt {
        color: #66686E;
        font-size: 18px;
        margin-bottom: 30px;
    }

    .vip-suc {
        img {
            display: block;
            width: 50px;
            height: 50px;
            margin: 0 auto;
        }

        p {
            color: #333439;
            font-size: 16px;
            font-weight: 400;
            text-align: center;
            line-height: 40px;
        }
    }

    .vip-t {
        color: #989DA2;
        margin-top: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/vip/vip.vue